
import BaseFilter from '@/components/filters/Filter';
import { Option } from '@/components/SelectPicker.vue';
import type { FilterRangeMultipleFieldsMetadata, FilterRangeMultipleFieldsValue } from './filterValueFunctions';

export default BaseFilter.extend({
	props: {
		value: {
			type: Object as () => FilterRangeMultipleFieldsValue,
			required: true,
			default: (): FilterRangeMultipleFieldsValue => ({
				low: '',
				high: '',
				mode: 'strict'
			})
		},
	},
	computed: {
		fields(): FilterRangeMultipleFieldsMetadata { return this.definition.metadata; },
		modes(): Option[] {
			return [{
				value: 'permissive',
				label: this.$t('filter.range.permissive').toString(),
				title: this.$t('filter.range.permissiveDescription').toString()
			}, {
				value: 'strict',
				label: this.$t('filter.range.strict').toString(),
				title: this.$t('filter.range.strictDescription').toString()
			}]
		},
	}
});
